interface AppEnv {
    REACT_APP_API_HOST: string;
}

const { REACT_APP_API_HOST } = (process.env as any) as AppEnv;

export const API_HOST = REACT_APP_API_HOST;
export const isLogsEnabled = true;
